import React from 'react';
import { useContext, useEffect, useRef } from 'react';
import { Button, IconButton, Typography } from '@mui/material';
import { CaptureContext } from './CaptureProvider';
import { CaptureBannerContent, CaptureBorder, CaptureWrapper } from './CaptureBannerStyled';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

const CaptureBanner = () => {
    const { t } = useTranslation('hypertracker_capture');
    const { isActive, stop, capture } = useContext(CaptureContext);
    const ref = useRef<HTMLDivElement | null>(null);
    const api = useContext(CaptureContext) as any;
    useEffect(() => {
        api?._registerBanner?.(ref.current);
        return () => api?._registerBanner?.(null);
    }, []);

    if (!isActive) {
        return null;
    }

    const onCapture = async () => {
        try {
            await capture();
        } catch (error) {
            console.error('Capture failed:', error);
        }
    };

    return (
        <>
            <CaptureBorder />
            <CaptureWrapper ref={ref} className="cmm-capture-banner" data-html2canvas-ignore="true">
                <CaptureBannerContent>
                    <Typography variant="p12" color={'common.black'}>
                        {t('banner_text')}
                    </Typography>
                    <Button
                        variant="contained"
                        color="hypertracker"
                        size={'small'}
                        onClick={onCapture}
                        sx={{
                            backgroundColor: 'rgba(0, 0, 0, 0.50);',
                            color: '#FFFFFF',
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.70);',
                            },
                        }}
                    >
                        <Typography color={'common.white'} variant={'p12'}>
                            {t('capture_button')}
                        </Typography>
                    </Button>
                    <IconButton sx={{ padding: '4px' }} onClick={stop}>
                        <CloseIcon sx={{ width: '16px', height: 'auto', path: { fill: '#000' } }} />
                    </IconButton>
                </CaptureBannerContent>
            </CaptureWrapper>
        </>
    );
};

export default CaptureBanner;
